module.exports = __webpack_public_path__ + "static/media/WeatherApp.20583c69.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/WeatherApp.JPG
// module id = 287
// module chunks = 0